import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, MenuItem, IconButton, Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Drawer from "./Drawer";

import "./Navbar.css";

const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isDrawerVisible, setDrawerVisible] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    sessionStorage.clear("token");
    navigate("/");
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1100) {
        setDrawerVisible(true);
      } else {
        setDrawerVisible(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setAnchorEl(null);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="navbar-container1">
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={10} md={8} lg={9}>
          <div className="search-box1">
            {isDrawerVisible && <Drawer />}
            <IconButton className="search-icon1">
              <SearchIcon />
            </IconButton>
            <input
              type="text"
              className="search-field1"
              placeholder="Search..."
            />
          </div>
        </Grid>
        <Grid item xs={2} md={4} lg={3}>
          <div className="profile-icon1" ref={menuRef}>
            <IconButton
              onClick={handleClick}
              aria-controls="profile-menu"
              aria-haspopup="true"
            >
              <AccountCircleIcon />
            </IconButton>
            <Menu
              id="profile-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
            >
              <MenuItem>My Profile</MenuItem>
              <MenuItem>Settings</MenuItem>
              <MenuItem onClick={handleClose}>Logout</MenuItem>
            </Menu>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Navbar;
